import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCategory } from "@store/Store/Data/Categories/CategoriesSelectors";
import { useSelector } from "react-redux";

export const useCategory = () => {
    return useSelector((state: ApplicationState) => {
        return getCategory(state);
    });
};

export default useCategory;
